import React from "react";
import { Facebook, Twitter, MessageCircle, Send, Link as LinkIcon } from "lucide-react";

const NETWORKS = [
  {
    id: "facebook",
    icon: Facebook,
    label: "Facebook",
    color: "#1877F2",
    url: (u, t) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(u)}&quote=${encodeURIComponent(t)}`,
  },
  {
    id: "twitter",
    icon: Twitter,
    label: "X",
    color: "#000000",
    url: (u, t) => `https://twitter.com/intent/tweet?url=${encodeURIComponent(u)}&text=${encodeURIComponent(t)}`,
  },
  {
    id: "whatsapp",
    icon: MessageCircle,
    label: "WhatsApp",
    color: "#25D366",
    url: (u, t) => `https://wa.me/?text=${encodeURIComponent(t + " " + u)}`,
  },
  {
    id: "telegram",
    icon: Send,
    label: "Telegram",
    color: "#26A5E4",
    url: (u, t) => `https://t.me/share/url?url=${encodeURIComponent(u)}&text=${encodeURIComponent(t)}`,
  },
];

export default function ShareButtons({ title = "Eiffel 65 Fan Portal", url, dataTestId = "share" }) {
  const finalUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const [copied, setCopied] = React.useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(finalUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // ignore — older browsers without clipboard API
    }
  };

  return (
    <div data-testid={`${dataTestId}-bar`} className="inline-flex items-center gap-1.5 flex-wrap">
      <span className="text-[10px] uppercase tracking-[0.3em] text-white/40 font-bold mr-1 hidden sm:inline">Teilen</span>
      {NETWORKS.map((n) => (
        <a
          key={n.id}
          href={n.url(finalUrl, title)}
          target="_blank"
          rel="noreferrer noopener"
          data-testid={`${dataTestId}-${n.id}`}
          aria-label={`Share on ${n.label}`}
          className="w-9 h-9 grid place-items-center rounded-full border border-white/10 text-white/70 hover:scale-110 hover:border-current transition-all"
          style={{ "--c": n.color }}
        >
          <n.icon size={14} className="hover:text-[var(--c)] transition-colors" style={{ color: "currentColor" }} />
        </a>
      ))}
      <button
        type="button"
        onClick={copy}
        data-testid={`${dataTestId}-copy`}
        aria-label="Copy link"
        className={`w-9 h-9 grid place-items-center rounded-full border transition-all ${copied ? "border-[#22C55E] text-[#22C55E] bg-[#22C55E]/15" : "border-white/10 text-white/70 hover:border-[#00AFFF] hover:text-[#00AFFF]"}`}
      >
        <LinkIcon size={14} />
      </button>
      {copied && <span className="text-[10px] text-[#22C55E] font-display font-bold uppercase">Kopiert!</span>}
    </div>
  );
}
